import { useStore } from './index';

export const ResetSlicesForAccountSwitching = () => {
  const {
    resetErrorSlice,
    resetActiveTransactions, resetStatementsListSlice, resetExpensesListSlice,
    resetUncategorizedTransactionsSlice, resetDashboardDataSlice, resetScheduleCDataSlice,
    resetUserMessageSlice, resetRedirectionSlice, resetInvoicesSlice, resetMailCheckSlice,
    resetAddBillSlice, resetVendorSlice, resetUnpaidBillsSlice, resetPaidBillsSlice,
    resetTransactionsSlice,
  } = useStore.getState();
  const clearMethods = [resetErrorSlice,
    resetActiveTransactions, resetStatementsListSlice, resetExpensesListSlice,
    resetUncategorizedTransactionsSlice, resetDashboardDataSlice, resetScheduleCDataSlice, resetUserMessageSlice,
    resetRedirectionSlice, resetInvoicesSlice, resetMailCheckSlice, resetAddBillSlice,
    resetVendorSlice, resetUnpaidBillsSlice, resetPaidBillsSlice, resetTransactionsSlice];

  clearMethods.forEach(cb => {
    cb();
  });
};
